import { Copy, CheckCircle2 } from "lucide-react";
import { useLocation } from "react-router-dom";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import styles from "./PagamentoPix.module.scss";

export const PagamentoPix = () => {
  const { state } = useLocation();

  const qrCodeUrl = state?.qrCodeUrl;
  const copiaCola = state?.qrCode;
  const valor = state?.valor;

  const copiarPix = async () => {
    if (!copiaCola) return;

    await navigator.clipboard.writeText(copiaCola);

    alert("Código PIX copiado.");
  };

  return (
    <PageContainer title="Pagamento PIX">
      <div className={styles.page}>

        <CheckCircle2
          size={55}
          className={styles.icon}
        />

        <h2>Aguardando pagamento</h2>

        <p>
          Valor:
          <strong> {valor}</strong>
        </p>

        {qrCodeUrl && (
          <img
            src={qrCodeUrl}
            alt="QR Code PIX"
            className={styles.qrcode}
          />
        )}

        <textarea
          readOnly
          value={copiaCola}
          className={styles.codigo}
        />

        <button
          className={styles.btn}
          onClick={copiarPix}
        >
          <Copy size={18}/>
          Copiar código PIX
        </button>

      </div>
    </PageContainer>
  );
};